// useOutstaffService, Выбор услуги аутстафф в договоре
import { useEffect, useState, useMemo } from 'react';
import { useStaffStore, useDepartmentsStore, useContractsStore } from 'storeZustand';
import { useShallow } from 'zustand/react/shallow';
import { getContractServices } from 'services';

const useContractService = (contract_service = []) => {
	const [contractServices, setContractServices] = useState([]);
	const [selectedContractService, setSelectedContractService] = useState([]);

	// получение списка внешних компаний
	useEffect(() => {
		const fetchData = async () => {
			const services = await getContractServices();
			setContractServices(services);
		}
		fetchData();
	}, []);

	// Выбранная услуга при редактировании
	useEffect(() => {
		setSelectedContractService(contract_service);
	}, [contract_service]);

	// Список услуг аутстафф для селекта
	const contractServicesList = useMemo(() => {
		return contractServices?.map((service) => ({
			value: service.id,
			label: `${service.name} (${service.price})`,
		})) ?? [];
	}, [contractServices]);

	const handleServiceChange = (value) => {
		setSelectedContractService([value]);
	};

	return {
		contractServicesList,
		selectedContractService,
		handleServiceChange
	};
};

export default useContractService;